import { useEffect } from 'react';
import { useDatasetDataRes } from '../api/types/types';

export const useSelectedRowsChangedCachedQueryGuard = (
  oldCachedQueryId: string | undefined,
  datasetData: useDatasetDataRes,
  datasetIdToCompare: string | undefined,
  onCacheReset: () => void
) => {
  useEffect(() => {
    if (datasetData && datasetData.datasetId === datasetIdToCompare) {
      if (
        datasetData.lazy &&
        datasetData.cachedQueryId !== oldCachedQueryId &&
        datasetData.cachedQueryId !== undefined
      ) {
        onCacheReset();
      }
    }
  }, [datasetData]);
};
